import React, { useCallback } from 'react';
import { DealType } from '@search/filter-enums/enums';
import { DealTypeFilter } from '../../../../models/Filter';
import { SlimSelect } from '../../../../../common/components/SlimSelect/SlimSelect';

interface IProps {
    filter: DealTypeFilter;
    enabledItems?: DealType[];
    onChange: (filter: DealTypeFilter) => void;
}

function getSelectOptions(enabledItems: DealType[]) {
    return SELECT_OPTIONS.map(item => ({
        ...item,
        disabled: ! enabledItems.includes(Number(item.value))
    }));
}

const SELECT_OPTIONS = [
    {
        value: DealType.SELL.toString(),
        label: 'Купить'
    },
    {
        value: DealType.RENT.toString(),
        label: 'Снять'
    }
];

export const DesktopDealTypeFilterView: React.FC<IProps> = ({
    filter,
    enabledItems = [ DealType.SELL, DealType.RENT ],
    onChange,
}) => {
    const options = getSelectOptions(enabledItems);

    const handleChange = useCallback(
        (val: string) => {
            const parsedValue = parseInt(val, 10) as DealType;

            onChange(new DealTypeFilter(parsedValue));
        },
        [ onChange ]
    );

    return (
        <SlimSelect
            dataTest='dealType'
            size='s'
            placeholder='Тип сделки'
            options={options}
            value={filter.dealType.toString()}
            onChange={handleChange}
            adaptiveHeight={false}
            adaptivePlacement={false}
        />
    );
};
